import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export const Loading = () => (
  <Box
    sx={{
      gap: '1rem',
      display: 'flex',
      height: '35rem',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
    }}
  >
    <Typography variant="h6" component="span">
      Processing
    </Typography>

    <CircularProgress />
  </Box>
);
